
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pharm-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './pharm-sidebar.html',
  styleUrl: './pharm-sidebar.css'
})
export class PharmSidebar {
  sidebarOpen = false;

  constructor(private router: Router) {}

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  confirmLogout() {
    if (confirm('Are you sure you want to logout?')) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      this.router.navigate(['/login']);
    }
  }
}
